import React, { PropTypes } from 'react';
import { findIndex, forEach, includes } from 'lodash';

import 'inventory-listing/components/ListingFilters/Components/MetadataButtonContainer/MetadataButtonContainer.scss';

import { LocaleService, UrlService } from '@sm360/widget-commons-core-services';

import MetaDataModel from 'inventory-listing/models/MetaDataModel.js';
import MetadataButton from 'inventory-listing/components/ListingFilters/Components/MetadataButtonContainer/MetadataButton.jsx';

class MetadataButtonContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            metadatas: this.getSelectionFromUrlParams(props.metadatas),
        };

        this.handleChange = this.handleChange.bind(this);
        this.resetSettings = this.resetSettings.bind(this);
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            metadatas: this.getSelectionFromUrlParams(newProps.metadatas),
        });
    }

    getSelectionFromUrlParams(metadatas) {
        const queryParamOptions = UrlService.getUrlParameter(this.props.filterName);
        const selectedOptions = queryParamOptions ? queryParamOptions.split(',') : [];

        return metadatas.map((option) => {
            return option.set('isSelected', includes(selectedOptions, option.code));
        });
    }

    handleChange(code) {
        const { metadatas } = this.state;
        const index = findIndex(metadatas, { code });

        metadatas[index] = metadatas[index].set('isSelected', !metadatas[index].isSelected);

        this.props.updateVehicleCriteria(metadatas, this.props.filterName);

        this.setState({
            metadatas,
        });
    }

    resetSettings(event) {
        event.preventDefault();

        const { metadatas } = this.state;

        forEach(metadatas, (option, index) => {
            metadatas[index] = option.set('isSelected', false);
        });

        this.props.updateVehicleCriteria(metadatas, this.props.filterName);

        this.setState({
            metadatas,
        });
    }

    render() {
        const metadatas = this.state.metadatas
            .filter(({ label }) => !!label)
            .map((metadata) => (
                <MetadataButton metadata={metadata} key={metadata.code} handleChange={this.handleChange} />
            ));

        return (
            <div className="listing-used-filters-bloc listing-used-metadata-container">
                <div className="listing-used-filters-title listing-used-filters-title-option is-bold">
                    {this.props.groupTitle}
                    <button className="listing-used-filters-clear sr-link is-regular" onClick={this.resetSettings}>
                        {LocaleService.t('BUTTONS.CLEAR')}
                    </button>
                </div>
                <div className="metadata-list">{metadatas}</div>
            </div>
        );
    }
}

MetadataButtonContainer.defaultProps = {
    metadatas: [],
};

MetadataButtonContainer.propTypes = {
    metadatas: PropTypes.arrayOf(PropTypes.instanceOf(MetaDataModel)),
    updateVehicleCriteria: PropTypes.func.isRequired,
    filterName: PropTypes.string.isRequired,
    groupTitle: PropTypes.string.isRequired,
};

MetadataButtonContainer.displayName = 'MetadataButtonContainer';

export default MetadataButtonContainer;



// WEBPACK FOOTER //
// ./client/src/components/ListingFilters/Components/MetadataButtonContainer/MetadataButtonContainer.jsx